module.exports = __webpack_public_path__ + "media/invite/delete-39dc35c3.svg";